/**
 * @generated SignedSource<<caf5ee8a635e003641b575392964526f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type templateCardContentfulRelayFragment$data = {
  readonly contributor: {
    readonly __typename: "Author";
    readonly organization: {
      readonly organizationNameExternal: string | null | undefined;
    } | null | undefined;
  } | {
    readonly __typename: "CompanyNameInternal";
    readonly organizationNameExternal: string | null | undefined;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
  readonly pluginModuleKey: string | null | undefined;
  readonly previewBlurb: string | null | undefined;
  readonly sys: {
    readonly id: string;
  };
  readonly templateNameExternal: string | null | undefined;
  readonly templateTypeCollection: {
    readonly items: ReadonlyArray<{
      readonly sys: {
        readonly id: string;
      };
      readonly templateTypeNameExternal: string | null | undefined;
    } | null | undefined>;
  } | null | undefined;
  readonly urlSlug: string | null | undefined;
  readonly " $fragmentType": "templateCardContentfulRelayFragment";
};
export type templateCardContentfulRelayFragment$key = {
  readonly " $data"?: templateCardContentfulRelayFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"templateCardContentfulRelayFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "concreteType": "Sys",
  "kind": "LinkedField",
  "name": "sys",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "organizationNameExternal",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "templateCardContentfulRelayFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "templateNameExternal",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "urlSlug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pluginModuleKey",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "previewBlurb",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductTemplateTemplateTypeCollection",
      "kind": "LinkedField",
      "name": "templateTypeCollection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TaxonomyTemplateType",
          "kind": "LinkedField",
          "name": "items",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "templateTypeNameExternal",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "contributor",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "CompanyNameInternal",
              "kind": "LinkedField",
              "name": "organization",
              "plural": false,
              "selections": (v1/*: any*/),
              "storageKey": null
            }
          ],
          "type": "Author",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v1/*: any*/),
          "type": "CompanyNameInternal",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProductTemplate",
  "abstractKey": null
};
})();

(node as any).hash = "6185ffb3a68cb45e8c6384f28e728c05";

export default node;
